<template>
  <div v-if="list.length > 0">
    <h2>{{ title }}</h2>
    <table style="margin-top: 10px">
      <thead>
        <tr>
          <th scope="col">Date</th>
          <th scope="col">Type</th>
          <th scope="col">Payment Deduction</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(tableItem, idx) in list" :key="idx">
          <td>{{ formatDate(tableItem.date) }}</td>
          <td>
            <div class="table-value-group">
              <div>{{ tableItem.t }}</div>
            </div>
          </td>
          <td v-if="editable">
            <div class="table-value-group" v-if="!tableItem.ignore_attendance">
              <input type="number" v-model.number="list[idx].deduction" />
              <div
                class="green-label pointer"
                @click="updateTimeoff(tableItem)"
              >
                SAVE
              </div>
              <div class="red-label pointer" @click="deleteTimeoff(tableItem)">
                DELETE
              </div>
            </div>
            <div class="table-value-group" v-else>-</div>
          </td>
          <td v-else>{{ tableItem.deduction }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td></td>
          <td>Total</td>
          <td>{{ total }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { http } from '../digilib_web/core/digitify';

export default {
  computed: {
    editable() {
      return this.profile.role === 'admin';
    },
    total() {
      let rows = this.list;
      let total = 0;
      for (let i = 0; i < rows.length; ++i) {
        total += rows[i].deduction;
      }
      return `Rp. ${total.toLocaleString()}`;
    },
    timeoffs() {
      return [];
    }
  },
  props: {
    id: Number,
    profile: Object,
    list: Array,
    title: String
  },
  methods: {
    formatDate(d) {
      return dayjs(d).format('ddd, DD MMM YYYY');
    },
    updateTimeoff(item) {
      let payload = { deduction: item.deduction };
      http.put(`employees/timeoffs/${item.id_timeoff}`, payload).then(json => {
        console.log(json);
        this.$emit('shouldReload');
      });
    },
    deleteTimeoff(item) {
      if (confirm('Are you sure to delete?')) {
        http.del(`employees/timeoffs/${item.id_timeoff}`).then(json => {
          this.$emit('shouldReload');
        });
      }
    }
  }
};
</script>
